import { Box, Typography } from '@mui/material';
import { InfoOutlined, WarningAmberOutlined, ErrorOutline, CheckCircleOutline } from '@mui/icons-material';
import Styles from './InfoNotice.module.scss';

/**
 * InfoNotice component for displaying contextual messages.
 * @param {string} message - Message text to display.
 * @param {string} type - Message type (info, warning, error, success).
 */

export function InfoNotice({ message, type = "info" }) {

    if (!message) {
        return null;
    }

    const icons = {
        info: <InfoOutlined fontSize="large" />,
        warning: <WarningAmberOutlined fontSize="large" />,
        error: <ErrorOutline fontSize="large" />,
        success: <CheckCircleOutline fontSize="large" />
    };

    return (
        <Box className={`${Styles.notice} ${Styles[type]}`}>
            {icons[type]}

            <Typography
                variant="body2"
                sx={{
                    fontWeight: 700,
                    lineHeight: 1.5
                }}
            >
                {message}
            </Typography>
        </Box>
    );
}
